import type { Profile } from "~/types/profile";
import type { Dashboard } from "~/types/dashboard";

/**
 *
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  // Check if JWT token is empty and auth params is in the url

  const {
    public: { inpCookieDomain },
  } = useRuntimeConfig();

  const jwt = useCookie("jwt", {
    domain: <string>inpCookieDomain,
  });

  if (!jwt.value && to.query.auth) {
    // Set JWT token and log-in user
    jwt.value = to.query.auth as string;
  }

  const availableRoutesForAnonymous = [
    "accedi",
    "iscriviti",
    "password-dimenticata",
    "reset-password",
  ];
  if (availableRoutesForAnonymous.includes(<string>to.name)) return;

  const user = useState<Profile | false>("profile");
  const dashboard = useState<Dashboard>("dashboard");
  const router = useRouter();

  const { loadProfile } = useProfile();
  const { loadDashboard } = useDashboard();

  // Eseguo la verifica solo una volta
  if (user.value && user.value.id) {
    const { isAdmin } = useProfile();
    // Se è presente un ID utente me lo porto dietro per tenere abilitata la visualizzazione di un admin
    if (from.query.uid && isAdmin.value) {
      to.query.uid = from.query.uid;
    }
    return;
  }

  // carico user
  user.value = await loadProfile();
  if (!user.value) {
    await router.push("/accedi");
    return;
  }

  if (user.value.isA && to.query.uid) {
    // carico i dati della dashboard dell'utente passato
    dashboard.value = await loadDashboard(parseInt(<string>to.query.uid));
  } else {
    // carico i dati della dashboard
    dashboard.value = await loadDashboard();
  }
});
